import splitRangeIntoTwoPartsIfItIsCircular from "./splitRangeIntoTwoPartsIfItIsCircular";
import trimRangeByAnotherRange from "./trimRangeByAnotherRange";
export default function adjustRangeToDeletionOfAnotherRange(rangeToBeAdjusted, anotherRange, maxLength) {
  const trimmedRange = trimRangeByAnotherRange(
    rangeToBeAdjusted,
    anotherRange,
    maxLength
  );
  if (!trimmedRange) {
    return null;
  }
  const nonCircularDeletionRanges = splitRangeIntoTwoPartsIfItIsCircular(
    anotherRange,
    maxLength
  );
  nonCircularDeletionRanges.forEach(function(nonCircularDeletionRange) {
    const deletionLength = nonCircularDeletionRange.end - nonCircularDeletionRange.start + 1;
    if (trimmedRange.start > trimmedRange.end) {
      if (nonCircularDeletionRange.start < trimmedRange.end) {
        trimmedRange.start -= deletionLength;
        trimmedRange.end -= deletionLength;
      } else if (nonCircularDeletionRange.start < trimmedRange.start) {
        trimmedRange.start -= deletionLength;
      } else {
      }
    } else {
      if (nonCircularDeletionRange.start < trimmedRange.start) {
        trimmedRange.start -= deletionLength;
        trimmedRange.end -= deletionLength;
      } else if (nonCircularDeletionRange.start < trimmedRange.end) {
        trimmedRange.end -= deletionLength;
      } else {
      }
    }
  });
  return trimmedRange;
}
